import script from "./videoAmplify.vue?vue&type=script&setup=true&lang=ts"
export * from "./videoAmplify.vue?vue&type=script&setup=true&lang=ts"

import "./videoAmplify.vue?vue&type=style&index=0&id=01e9a0c1&scoped=true&lang=scss"

import exportComponent from "/Users/123imac-49/Desktop/123-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e9a0c1"]])

export default __exports__